import { gsap } from 'gsap/dist/gsap';

/**************************************************************
-> Launch image lightbox when image is clicked
**************************************************************/
export function imageLightboxes() {

  const buttons = Array.from(document.querySelectorAll('[data-image-lightbox-button]'))

  if (buttons) {

    buttons.forEach(button => {
      const lightbox = document.querySelector(`[data-lightbox-image="${button.dataset.imageId}"]`)
      const close = lightbox.querySelector('[data-button-contract]')

      button.addEventListener('click', () => {
        document.body.style.overflow = 'hidden'
        gsap.to(lightbox, { opacity: '100%', pointerEvents: 'all'})
      })
      
      close.addEventListener('click', () => {
        document.body.style.overflow = 'initial'
        gsap.fromTo(lightbox, {opacity: '100%'}, { opacity: '0%', pointerEvents: 'none'})
      })

    })

    const lightboxes = Array.from(document.querySelectorAll('[data-lightbox-image] figure'))
    let mouseX = 0
    let mouseY = 0

    document.addEventListener('mousemove', (e) => {
      mouseX = e.x
      mouseY = e.y
    })

    lightboxes.forEach(lightbox => {
      const zoomButton = lightbox.querySelector('[data-button-zoom]')

      if (zoomButton) {
        const zoomInIcon = zoomButton.querySelector('.icon-zoom-in')
        const zoomOutIcon = zoomButton.querySelector('.icon-zoom-out')
        const image = lightbox.querySelector('.image-container img')

        zoomButton.addEventListener('click', () => {
          console.log(zoomButton.dataset.zoomState)

          if (zoomButton.dataset.zoomState === 'out') {
            zoomButton.dataset.zoomState = 'in'
            gsap.to(zoomInIcon, { opacity: 0 })
            gsap.to(zoomOutIcon, { opacity: 1 })
            image.style.transform = 'scale(2)';
          } else {
            zoomButton.dataset.zoomState = 'out'
            gsap.to(zoomInIcon, { opacity: 1 })
            gsap.to(zoomOutIcon, { opacity: 0 })
            image.style.transform = 'scale(1)';
            image.style.objectPosition = '0% 0%';
          }
        })

        lightbox.addEventListener('mousemove', () => {
          if (zoomButton.dataset.zoomState === 'in') {
            const xPos = mouseX/lightbox.offsetWidth*100
            const yPos = mouseY/lightbox.offsetHeight*100
            image.style.objectPosition = `${xPos}% ${yPos}%`
          }
        })
      }
    })

  }

}


// WEBPACK FOOTER //
// ./scripts/components/image-lightbox.js